module.exports = __webpack_public_path__ + "static/media/jahit.ef6d0998.jpeg";